// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import _searchModule from "@insite/content-library/Widgets/Header/HeaderSearchInput";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { layoutContainer } from "@werner/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

export interface SearchStyles {
    searchWrapper?: InjectableCss;
}

export const searchStyles: SearchStyles = {
    searchWrapper: {
        css: css`
            display: flex;
            align-items: center;
            height: 100%;
            width: 100%;
            ${layoutContainer}
            & > div {
                width: 100%;
            }
            && .autocomplete-column-wrapper {
                width: 100%;
            }
        `,
    },
};

const styles = searchStyles;

function Search(props: any) {
    // XNG-Changes: remove animated
    const headerSearchInput = createWidgetElement("Header/HeaderSearchInput", { ...props });

    return <StyledWrapper {...styles.searchWrapper}>{headerSearchInput}</StyledWrapper>;
}

const widgetModule: WidgetModule = {
    component: Search,
    definition: {
        group: "Compact Header",
        icon: "magnifying-glass",
        allowedContexts: ["CompactHeader"],
        fieldDefinitions: _searchModule.definition.fieldDefinitions,
    },
};

export default widgetModule;
